import type { Template } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useImageUpload } from '../../../components/tiptap/hooks/useImageUpload';
import { getParticipantNoteTemplateExtensions } from '../../../components/tiptap/utils';
import { useAppContext } from '../../../hooks/useAppContext';
import { TemplateEditor } from '../TemplateEditor';
import { TemplateTitleBar } from '../TemplateTitleBar';

interface Props {
  template: Template;
}

export const ParticipantNoteTemplateEditor = (props: Props) => {
  const { template } = props;

  const { organization, config } = useAppContext();

  const onImageUpload = useImageUpload({
    imageUploadUrl: `${config.api.webUrl}/organizations/${organization.id}/templates/${template.id}/images`,
  });

  const extensions = getParticipantNoteTemplateExtensions({ onImageUpload });

  return (
    <ChakraV3.Stack borderTopWidth='1px' borderColor='gray.200' h='full'>
      <TemplateEditor
        documentId={`template/${template.id}`}
        extensions={extensions}
        isEditable
        title={(options) => <TemplateTitleBar template={template} {...options} />}
        sidebarContent={() => null}
      />
    </ChakraV3.Stack>
  );
};
